import type { ToasterProps } from "sonner";
import { Toaster as Sonner } from "sonner";

const Toaster = ({
  toastOptions: callerToastOptions,
  className,
  ...props
}: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className={["toaster", "group", className].filter(Boolean).join(" ")}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--width": "380px",
        } as React.CSSProperties
      }
      toastOptions={{
        ...callerToastOptions,
        classNames: {
          ...callerToastOptions?.classNames,
          closeButton: [
            "transition-colors",
            callerToastOptions?.classNames?.closeButton,
          ]
            .filter(Boolean)
            .join(" "),
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
